import React from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import Button from "@mui/material/Button";

import { withStyles } from "tss-react/mui";
import customPaginationStyle from "./customPaginationStyle.jsx";
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";

class CustomPagination extends React.Component {
  state = {
    total_pages: this.props.total_pages,
    max_items: this.props.max_items,
  };

  buildPages = () => {
    let main = [];
    let prefix = [];
    let suffix = [];

    if (this.props.current_page > 1) {
      prefix.push({
        value: "prev",
        text: <TranslationWrapper tDefault={"Vorige"} tKey={"global.pagination.vorige"} />,
      });
    }

    let start = 1;

    if (this.state.total_pages > this.state.max_items && this.props.current_page - 4 > 0) {
      prefix.push({ value: 1, text: 1 });
      prefix.push({ value: "", text: "...", disabled: true });
      start = this.props.current_page - 2;
    }

    let end = this.state.total_pages;
    if (this.state.total_pages > this.state.max_items && this.props.current_page <= this.state.total_pages - 3) {
      suffix.push({ value: "", text: "...", disabled: true });
      suffix.push({
        value: this.state.total_pages,
        text: this.state.total_pages,
      });
      end = this.props.current_page + (this.props.current_page - 2 > 0 ? 2 : 5);
    }

    if ((this.state.total_pages && this.props.current_page !== this.state.total_pages) || this.props.nextPageCursor) {
      suffix.push({
        value: "next",
        text: <TranslationWrapper tDefault={"Volgende"} tKey={"global.pagination.volgende"} />,
      });
    }

    let i;
    for (i = start; i < end + 1; i++) {
      main.push({ value: i, text: i, active: i === this.props.current_page });
    }

    if (!this.state.total_pages) {
      main.push({ value: this.props.current_page, text: this.props.current_page, active: true });
    }

    //Generate pages
    return [...prefix, ...main, ...suffix];
  };

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.total_pages !== prevProps.total_pages) {
      let newState = { ...this.state };
      newState.total_pages = this.props.total_pages;

      /**
       * Als de geselecteerde pagina groter is dan de max pagina dan de max pagina gebruiken
       * En onClick triggeren om de data op te halen
       */
      if (this.props.current_page > this.props.total_pages) {
        if (this.props.onClick) {
          this.props.onClick(this.props.total_pages);
        }
      }

      this.setState(newState);
    }
  }

  handleButtonClick = (page) => {
    let newPage = 1;
    if (page === "next" || page === "prev") {
      let currentPage = this.props.current_page;

      if (page === "next") {
        newPage = currentPage + 1;
      } else {
        newPage = currentPage - 1;
      }
    } else {
      newPage = page;
    }

    if (this.props.onClick) {
      this.props.onClick(newPage, page);
    }
  };

  render() {
    const { classes, color } = this.props;

    return (
      <ul className={classes.pagination}>
        {this.buildPages().map((prop, key) => {
          const paginationLink = cx({
            [classes.paginationLink]: true,
            [classes[color]]: prop.active,
            [classes.disabled]: prop.disabled,
          });

          return (
            <li className={classes.paginationItem} key={key}>
              {prop.disabled ? (
                <Button className={paginationLink}>{prop.text}</Button>
              ) : (
                <Button className={paginationLink} onClick={() => this.handleButtonClick(prop.value)}>
                  {prop.text}
                </Button>
              )}
            </li>
          );
        })}
      </ul>
    );
  }
}

CustomPagination.defaultProps = {
  color: "primary",
  max_items: 9,
};

CustomPagination.propTypes = {
  current_page: PropTypes.number.isRequired,
  total_pages: PropTypes.number,
};

export default withStyles(CustomPagination, customPaginationStyle);
